import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.184 9.187V5.649a4.304 4.304 0 0 0-8.607 0v3.538c0 .498-.132.986-.384 1.415h9.375a2.8 2.8 0 0 1-.384-1.415m2.869 2.83H.708a.708.708 0 1 1 0-1.415 1.425 1.425 0 0 0 1.434-1.415V5.649a5.739 5.739 0 0 1 11.476 0v3.538a1.425 1.425 0 0 0 1.435 1.415.708.708 0 0 1 0 1.416M9.74 14.496a2.165 2.165 0 0 1-3.722 0 .708.708 0 0 1 .62-1.062H9.12a.707.707 0 0 1 .62 1.062"
    }, null, -1)
  ]))]))
}
export default { render: render }